import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { RoleDefinition } from "@/server/types";
import { api } from "./apiClient";

export const useRoles = () => {
  return useQuery({
    queryKey: ["roles"],
    queryFn: () => api.getRoles(),
  });
};

export const useSaveRoles = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (roles: RoleDefinition[]) => api.saveRoles({ roles }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["roles"] });
    },
  });
};
